import { useEffect } from 'react'
import { useSettingsStore } from '@/stores/settingsStore'
import { useAuthStore } from '@/stores/authStore'

/**
 * Hook to manage application settings initialization and synchronization
 * This hook should be used at the app level to ensure settings are loaded when the user logs in
 */
export function useAppSettings() {
  const { user } = useAuthStore()
  const { fetchSettings, applyTheme, settings } = useSettingsStore()

  // Fetch settings when user logs in
  useEffect(() => {
    if (user) {
      fetchSettings().catch((error: unknown) => {
        console.error('Failed to load user settings:', error)
        // Continue with default settings if fetch fails
      })
    }
  }, [user, fetchSettings])

  // Apply theme changes immediately
  useEffect(() => {
    applyTheme(settings.theme)
  }, [settings.theme, applyTheme])

  return {
    settings,
    isInitialized: !!user,
  }
}
